import { ConnectorNames } from 'constants/types'
import { getWCProvider } from './walletConnectConnector'

const getProvider = () => {
  const { connectorId } = window.localStorage

  if (!connectorId) {
    return null
  }
  switch (connectorId) {
    case ConnectorNames.Injected:
      return (window as any).ethereum
    case ConnectorNames.WalletConnect:
      return getWCProvider()
    default:
      return null
  }
}

export default getProvider
